import { request } from '../request';

export type SingleShiftTemplatePresetCreateData = {
  name: string;
  startTime: string;
  durationInSeconds: number;
  locationId: string; // 'location-00000000000000000000000000';
};
export function createSingleShiftTemplatePreset(data: SingleShiftTemplatePresetCreateData) {
  return request.post<void>('/v2/templates/time-presets', {
    ...data,
  });
}
